import Cookies from 'js-cookie';
import { getPhoneVerified } from '../../../client';
import { isInAdminGroup } from '../../../util';

export const isPathAllowedWithoutPhoneVerify = (pathname) =>
  pathname === '/dashboard' || pathname === '/dashboard/';

export const isPhoneVerificationStatusKnown = () => {
  const payload = Cookies.getJSON('payload');
  if (!payload) {
    return false;
  }
  return payload.phone_verified !== undefined;
};

export const isPhoneVerificationPending = () => {
  if (isInAdminGroup()) {
    return false;
  }
  return !isPhoneVerificationStatusKnown();
};

export const shouldEnforcePhoneVerification = () => {
  if (isInAdminGroup()) {
    return false;
  }

  if (!isPhoneVerificationStatusKnown()) {
    return false;
  }

  return !getPhoneVerified();
};
